import React, { useRef, useEffect } from "react";
import cx from "components/src/utils/cx";
import Arrow from "./Arrow";
// import anime, { AnimeInstance } from "animejs";
import { MarketButtonArrowAnimationOptions, MarketButtonDataQaType, MarketButtonRoundedType } from "../types";

const roundedClasses = {
  sm: "cui-rounded-sm",
  md: "cui-rounded-md",
  lg: "cui-rounded-lg"
};

const ArrowIndicators = ({
  selected,
  oddsState,
  id,
  isViewable = true,
  animation,
  rounded,
  dataQa,
  isBoost
}: {
  selected: boolean;
  isViewable: boolean;
  oddsState: {
    UP: boolean;
    DOWN: boolean;
    EVEN: boolean;
  };
  isBoost?: boolean;
  id: string;
  animation: MarketButtonArrowAnimationOptions;
  rounded?: MarketButtonRoundedType;
  dataQa: MarketButtonDataQaType;
}) => {
  // const animeRef = useRef<AnimeInstance | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const roundedClass = rounded ? roundedClasses[rounded] : "cui-rounded-[2px]";

  // useEffect(() => {
  //   animeRef.current = anime({
  //     targets: [containerRef.current],
  //     opacity: [0, 1],
  //     duration: 500,
  //     direction: "alternate",
  //     loop: animation === "reduced" ? 4 : 6,
  //     easing: "linear",
  //     autoplay: false,
  //   });

  //   if (oddsState.EVEN || !isViewable || animation === "off") {
  //     animeRef.current?.pause();
  //   } else {
  //     animeRef.current?.restart();
  //   }
  //   return () => {
  //     animeRef.current = null;
  //   }
  // });

  return (
    <div
      ref={containerRef}
      className={cx(
        {
          "cui-ring-status-positive": oddsState.UP && !selected && !isBoost,
          "cui-ring-status-negative": oddsState.DOWN && !selected && !isBoost,
          "cui-ring-fg-global-black": !!isBoost && !oddsState.EVEN && !selected,
          "cui-ring-neutrals-transparent": oddsState.EVEN && !isBoost,
          "cui-ring-highlight-five": oddsState.EVEN && !!isBoost,
          "cui-ring-fg-inverse": ((oddsState.UP || oddsState.DOWN) || !!isBoost) && selected,
        },
        `${roundedClass} cui-absolute cui-inset-0 ${selected ? "cui-ring-[1.5px]" : "cui-ring-1"} cui-ring-solid cui-z-10`
      )}
      data-cy="market-button-arrow-indicators"
      data-qa={dataQa?.arrowIndicators}
    >
      <Arrow
        status="positive"
        movement={oddsState.UP}
        id={`positive-${id}`}
        selected={selected}
        color={isBoost && !selected ? "black" : ""}
        offset={rounded}
      />
      <Arrow
        status="negative"
        movement={oddsState.DOWN}
        id={`negative-${id}`}
        selected={selected}
        color={isBoost && !selected ? "black" : ""}
        offset={rounded}
      />
    </div>
  );
};

export default ArrowIndicators;
